<template>
  <v-container fluid :class="baseStore?.isDesktop ? 'pa-8' : 'pa-4'">
    <v-row class="home-layout">
      <v-col cols="12" md="9">
        <!-- Hero Section -->
        <v-row justify="center" :class="baseStore?.isDesktop ? 'my-2' : 'my-2'">
          <v-col cols="12">
   
          <!-- <v-card 
            elevation="1" 
            class="overflow-hidden" 
           
            :class="baseStore?.isDesktop ? 'pa-8' : 'pa-4'"
          > -->
            <v-row no-gutters align="center" class="hero-strip">
              <!-- Logo Sektion -->
              <v-col cols="12" md="4" class="text-center mb-4 mb-md-0">
                <div class="d-flex flex-column align-center">
                  <img
                    :src="require('@/assets/pickpoint.png')"
                    alt="PickPoint Logo"
                    :width="baseStore?.isDesktop ? 200 : 140"
                    class="mb-3"
                    
                  />
                  <!-- <h2 :class="baseStore?.isDesktop ? 'text-h5' : 'text-h6'" class="font-weight-bold text-blue text-center">
                    Power-Webinare
                  </h2>
                  <p class="text-body-2 text-grey-darken-1 text-center">
                    für Ihr Praxismanagement
                  </p> -->
                </div>
              </v-col>
              
              <!-- Features Sektion -->
              <v-col cols="12" md="8">
                <v-row no-gutters>
                  <v-col cols="4" class="mb-md-3 px-1">
                    <div class="text-center">
                      <v-avatar color="#e5e7eb" :size="baseStore?.isDesktop ? 56 : 40" class="mb-2 mb-md-3">
                        <v-icon color="#4b5563" :size="baseStore?.isDesktop ? 28 : 20">mdi-star-circle</v-icon>
                      </v-avatar>
                      <h4 :class="baseStore?.isDesktop ? 'text-subtitle-1' : 'text-subtitle-2'" class="font-weight-bold mb-1 mb-md-2 feature-headline">
                        "handverlesen"
                      </h4>
                      <p class="text-body-2 text-grey-darken-1 feature-subline">
                        Dozenten & Themen
                      </p>
                    </div>
                  </v-col>

                  <v-col cols="4" class="mb-md-3 px-1">
                    <div class="text-center">
                      <v-avatar color="#e5e7eb" :size="baseStore?.isDesktop ? 56 : 40" class="mb-2 mb-md-3">
                        <v-icon color="#4b5563" :size="baseStore?.isDesktop ? 28 : 20">mdi-clock-fast</v-icon>
                      </v-avatar>
                      <h4 :class="baseStore?.isDesktop ? 'text-subtitle-1' : 'text-subtitle-2'" class="font-weight-bold mb-1 mb-md-2 feature-headline">
                        20 Minuten
                      </h4>
                      <p class="text-body-2 text-grey-darken-1 feature-subline">
                        auf den Punkt
                      </p>
                    </div>
                  </v-col>

                  <v-col cols="4" class="mb-md-3 px-1">
                    <div class="text-center">
                      <v-avatar color="#e5e7eb" :size="baseStore?.isDesktop ? 56 : 40" class="mb-2 mb-md-3">
                        <v-icon color="#4b5563" :size="baseStore?.isDesktop ? 28 : 20">mdi-tooth</v-icon>
                      </v-avatar>
                      <h4 :class="baseStore?.isDesktop ? 'text-subtitle-1' : 'text-subtitle-2'" class="font-weight-bold mb-1 mb-md-2 feature-headline">
                        Für Profis
                      </h4>
                      <p class="text-body-2 text-grey-darken-1 feature-subline">
                        aus der Zahnmedizin
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

 
          </v-col>
        </v-row>
        <v-row justify="center" :class="baseStore?.isDesktop ? 'mb-12' : 'mb-6'">


          <v-col cols="12">
      
          <v-row no-gutters>
            <v-col cols="12" >
              <div class="d-flex align-center mb-6 home-title-wrap">
               <img :src="require('@/assets/pickerviolett.png')" alt="PickPoint Logo" class="mr-4 home-title-logo" />
                <h1 class="home-title">PickPoint <span style="font-weight: 300;">Webinare</span></h1>
              </div>
              <p class="text-body-2 text-grey-darken-1 mb-4">
                Pro Webinar wird der nächste verfügbare Termin angezeigt; ohne neue Termine ist das Webinar als abgeschlossen markiert.
              </p>
         
              
              <!-- Webinar Cards -->
              <v-row>
                <v-col cols="12">
               
                  <WebinarCard 
                    v-for="(webinar, index) in webinars" 
                    :key="index"
                    :webinar="webinar"
                    :base-store="baseStore"
                  />
                </v-col>
              </v-row>
              
              <!-- <v-btn 
                color="blue" 
                size="large" 
                variant="elevated"
                class="mt-4"
                block
                style="border-radius: 4px;"
              >
                <v-icon start>mdi-calendar-check</v-icon>
                Alle Webinare ansehen
              </v-btn> -->
            </v-col>
          </v-row>
 
          </v-col>
        </v-row>
    
        <!-- PickPoint Webinare Section -->
 
    
        <!-- Features Section -->
        <v-row justify="center" :class="baseStore?.isDesktop ? 'mt-12' : 'mt-6'">
          <v-col cols="12">
            <div :class="baseStore?.isDesktop ? 'text-center mb-8' : 'text-center mb-4'">
              <h2 :class="baseStore?.isDesktop ? 'text-h4' : 'text-h5'" class="font-weight-bold muted-headline mb-4">
                Warum Pickpoint Experten-Webinare?
              </h2>
              <p :class="baseStore?.isDesktop ? 'text-h6' : 'text-subtitle-1'" class="text-grey-darken-1 font-weight-light">
                Kurz. Knackig. Auf den Punkt.
              </p>
            </div>
            
            <v-row>
              <v-col 
                v-for="(feature, index) in features" 
                :key="index"
                cols="12" 
                sm="6"
                md="4"
              >
                <v-card
                  :class="baseStore?.isDesktop ? 'pa-6 h-100' : 'pa-3 h-100'"
                  elevation="1"
                  style="border-radius: 0;"
                >
                  <div class="feature-card-body">
                    <v-avatar
                      color="#e5e7eb"
                      :size="baseStore?.isDesktop ? 64 : 44"
                      class="feature-card-avatar"
                    >
                      <v-icon color="#4b5563" :size="baseStore?.isDesktop ? 32 : 22">{{ feature.icon }}</v-icon>
                    </v-avatar>
                    <div class="feature-card-text">
                      <h3 :class="baseStore?.isDesktop ? 'text-h6' : 'text-subtitle-1'" class="font-weight-bold feature-card-title">{{ feature.title }}</h3>
                      <p class="text-body-2 text-grey-darken-1 mb-0">{{ feature.description }}</p>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="3" class="hero-right">
        <a
          class="waizmann-box"
          href="https://www.teamwaizmann.de"
          target="_blank"
          rel="noopener"
        >
          <div class="waizmann-box-mark">®</div>
          <div class="waizmann-box-title">WaizmannTabellen anfordern</div>
          <div class="waizmann-box-footer">
            <div class="waizmann-box-original">das Original</div>
            <div class="waizmann-box-since">seit 1995</div>
          </div>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { inject, ref, onMounted } from "vue";
import WebinarCard from '@/components/objects/webinar/WebinarCard.vue';

const updateDocumentHead = inject('updateDocumentHead');
const baseStore = inject('baseStore');
const baseCalls = inject('baseCalls');
const loaderStore = inject('loaderStore');

// Titel sofort setzen (nicht warten auf onMounted)
updateDocumentHead(
  "PickPoint - Elite-Webinare für Ihr Praxismanagement",
  "Professionelle Webinare für Zahnärzte & ZFA - Praxisnahe Weiterbildung"
);

// Webinar Daten (dynamisch von API geladen)
const webinars = ref([]);

// Icon-Mapping für Webinare
const iconMapping = {
  'shield': 'mdi-shield-heart',
  'group': 'mdi-account-group',
  'tooth': 'mdi-tooth',
  'exit': 'mdi-exit-to-app',
  'default': 'mdi-school'
};

const colorMapping = {
  'green': 'green',
  'orange': 'orange',
  'blue': 'blue',
  'red': 'red',
  'default': 'primary'
};

function resolveDozentImage(imageName) {
  if (!imageName) return null;
  if (imageName.startsWith('/')) return imageName;

  try {
    return require(`@/assets/dozenten/${imageName}`);
  } catch (e) {
    // Fallback: bisheriger Public-Pfad, falls Asset lokal nicht vorhanden ist
    return `/dozenten/${imageName}`;
  }
}

// Webinare von API laden
async function getAlleWebinare() {
  try {
    loaderStore.setLoader(true, 'Webinare werden geladen...');
    const data = {
      action: 'getAlleWebinare'
    };
    const response = await baseCalls.webinarPost(data);
    
    if (response.data.success) {
      const allEntries = Array.isArray(response.data.webinare) ? response.data.webinare : [];

      // Pro Webinar-Art (webi_id) genau einen Eintrag erzeugen:
      // - mit zukünftigen Terminen: nächster Termin als Haupttermin + komplette Terminliste
      // - ohne zukünftige Termine: letzter vergangener Termin (=> abgeschlossen)
      const grouped = new Map();
      for (const entry of allEntries) {
        const key = entry.webi_id || entry.webi_title || entry.wter_id;
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(entry);
      }

      const toDate = (value) => {
        if (!value) return null;
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
      };

      const formatDate = (value) => {
        const d = toDate(value);
        if (!d) return null;
        return d.toLocaleDateString('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      };

      const now = Date.now();
      const normalized = [];

      grouped.forEach((entries) => {
        if (!entries || entries.length === 0) return;

        const sorted = [...entries].sort((a, b) => {
          const ta = toDate(a.wter_beginn)?.getTime() || 0;
          const tb = toDate(b.wter_beginn)?.getTime() || 0;
          return ta - tb;
        });

        const futureEntries = sorted.filter(item => {
          const t = toDate(item.wter_beginn)?.getTime();
          return t && t > now;
        });

        const selected = futureEntries[0] || sorted[sorted.length - 1];
        if (!selected) return;

        const dozentImage = selected.dozent_image
          ? resolveDozentImage(selected.dozent_image)
          : null;

        normalized.push({
          terminId: selected.wter_id,
          webinarId: selected.webi_id || null,
          title: selected.webi_title || 'Webinar',
          description: selected.webi_description || selected.webi_teaser || '',
          icon: iconMapping[selected.webi_icon] || iconMapping.default,
          color: colorMapping[selected.webi_color] || colorMapping.default,
          dozent: selected.webi_dozent || 'Frank Frenzel',
          dauer: selected.webi_laenge || 15,
          termin: formatDate(selected.wter_beginn),
          startsAt: selected.wter_beginn || null,
          hasUpcomingTermine: futureEntries.length > 0,
          termine: futureEntries.map(item => ({
            terminId: item.wter_id,
            startsAt: item.wter_beginn || null,
            label: formatDate(item.wter_beginn)
          })),
          dozentImage
        });
      });

      // Zukünftige zuerst (frühester kommender Termin oben), abgeschlossene danach
      webinars.value = normalized.sort((a, b) => {
        const ta = toDate(a.startsAt)?.getTime() || 0;
        const tb = toDate(b.startsAt)?.getTime() || 0;
        const aFuture = !!a.hasUpcomingTermine;
        const bFuture = !!b.hasUpcomingTermine;
        if (aFuture !== bFuture) return aFuture ? -1 : 1;
        return aFuture ? ta - tb : tb - ta;
      });

      console.log('✅ Webinare geladen:', webinars.value.length);
    }
    loaderStore.setLoader(false);
  } catch (error) {
    console.error('❌ Fehler beim Laden der Webinare:', error);
    loaderStore.setLoader(false);
  }
}

onMounted(() => {
  getAlleWebinare();
});


// Feature Daten
const features = ref([
  {
    title: "Praxisnah",
    description: "Alle Inhalte sind direkt in Ihrer Praxis umsetzbar und praxiserprobt",
    icon: "mdi-tools",
    color: "neutral"
  },
  {
    title: "Expertenwissen",
    description: "Von erfahrenen Praktikern für Praktiker - fundiert und aktuell",
    icon: "mdi-school",
    color: "neutral"
  },
  {
    title: "Auf den Punkt",
    description: "Lernen Sie in 15 Minuten auf den Punkt. Kein Blabla, nur das Wichtige.",
    icon: "mdi-clock-outline",
    color: "neutral"
  }
]);
</script>

<style scoped>
/* Alle Rundungen entfernen */
.v-card,
.v-btn,
.v-chip,
.v-avatar {
  border-radius: 0 !important;
}

.text-blue {
  color: #3d1b70 !important;
}

.hero-strip {
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
  padding: 20px;
  border-radius: 0;
}

.feature-headline {
  color: #374151;
}

.home-title-wrap {
  padding: 16px;
  border-radius: 0;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.home-title {
  font-size: clamp(26px, 6vw, 48px);
  line-height: 1.15;
  color: #374151;
}

.home-title-logo {
  width: 100px;
  flex-shrink: 0;
}

.muted-headline {
  color: #374151 !important;
}

/* "Warum..."-Karten: Desktop zentriert untereinander, Mobile als kompakte Zeile */
.feature-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.feature-card-avatar {
  margin-bottom: 16px;
}

.feature-card-title {
  margin-bottom: 12px;
}

.home-layout {
  align-items: flex-start;
  max-width: 1100px;
  margin: 0 auto;
}

.hero-right {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: min(260px, 100%);
  align-self: start;
  position: sticky;
  top: 120px;
}

.waizmann-box {
  background: #3166A5;
  color: #ffffff;
  border-radius: 4px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  aspect-ratio: 105 / 168;
  position: relative;
  text-decoration: none;
  width: min(260px, 100%);
  box-shadow: none;
}

.waizmann-box:hover {
  box-shadow: none;
}

.waizmann-box-mark {
  position: absolute;
  top: 6px;
  right: 8px;
  font-size: 12px;
  font-weight: 700;
  opacity: 0.9;
}

.waizmann-box-title {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
}

.waizmann-box-footer {
  position: absolute;
  right: 10px;
  bottom: 10px;
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.waizmann-box-original {
  font-size: 18px;
  font-weight: 700;
}

.waizmann-box-since {
  font-size: 15px;
  opacity: 0.9;
}

@media (max-width: 959px) {
  .hero-right {
    position: static;
    top: auto;
    width: 100%;
    align-items: center;
  }

  .waizmann-box {
    aspect-ratio: auto;
    min-height: 150px;
    width: min(320px, 100%);
  }
}

@media (max-width: 767px) {
  .hero-strip {
    padding: 12px 8px;
  }

  .home-title-wrap {
    padding: 12px;
  }

  .home-title-logo {
    width: 56px;
  }

  .feature-subline {
    font-size: 0.75rem !important;
    line-height: 1.3;
  }

  .feature-card-body {
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
    gap: 14px;
  }

  .feature-card-avatar {
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .feature-card-title {
    margin-bottom: 4px;
  }

  .waizmann-box {
    min-height: 120px;
    padding: 14px 16px;
  }

  .waizmann-box-title {
    font-size: 18px;
    padding-right: 16px;
  }

  .waizmann-box-original {
    font-size: 15px;
  }

  .waizmann-box-since {
    font-size: 13px;
  }
}
</style>